import { render } from "./EmployeeAddressList.vue?vue&type=template&id=6f81c5a4"
import script from "./EmployeeAddressList.vue?vue&type=script&lang=js"
export * from "./EmployeeAddressList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/employees/address/EmployeeAddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f81c5a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f81c5a4', __exports__)) {
    api.reload('6f81c5a4', __exports__)
  }
  
  module.hot.accept("./EmployeeAddressList.vue?vue&type=template&id=6f81c5a4", () => {
    api.rerender('6f81c5a4', render)
  })

}


export default __exports__